import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock } from 'lucide-react';
export function Pricing() {
  const strikethroughs = ['$562', '$297', '$97'];
  return <section id="pricing" className="py-24 px-6 bg-brand-bg relative overflow-hidden" data-id="element-48">
      <div className="absolute inset-0 bg-dots-pattern bg-dots-sm opacity-40 pointer-events-none" data-id="element-49"></div>
      <div className="relative max-w-3xl mx-auto" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-brand-cardDark/40 text-center relative overflow-hidden" data-id="element-51">
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-accent" data-id="element-52"></div>

          <h2 className="text-3xl md:text-4xl font-black uppercase text-brand-navy mb-8" data-id="element-53">
            Valor <span className="text-brand-accent" data-id="element-54">Total</span>
          </h2>

          <div className="space-y-3 text-lg text-brand-text/80 mb-8 max-w-sm mx-auto text-left" data-id="element-55">
            <div className="flex justify-between border-b border-brand-card pb-2" data-id="element-56">
              <span data-id="element-57">Guía principal:</span>{' '}
              <span className="font-medium" data-id="element-58">$97</span>
            </div>
            <div className="flex justify-between border-b border-brand-card pb-2" data-id="element-59">
              <span data-id="element-60">Bono #1:</span> <span className="font-medium" data-id="element-61">$47</span>
            </div>
            <div className="flex justify-between border-b border-brand-card pb-2" data-id="element-62">
              <span data-id="element-63">Bono #2:</span> <span className="font-medium" data-id="element-64">$67</span>
            </div>
            <div className="flex justify-between border-b border-brand-card pb-2" data-id="element-65">
              <span data-id="element-66">Bono #3:</span> <span className="font-medium" data-id="element-67">$97</span>
            </div>
            <div className="flex justify-between border-b border-brand-card pb-2" data-id="element-68">
              <span data-id="element-69">Bono #4:</span> <span className="font-medium" data-id="element-70">$57</span>
            </div>
            <div className="flex justify-between border-b border-brand-card pb-2" data-id="element-71">
              <span data-id="element-72">Bono #5:</span> <span className="font-medium" data-id="element-73">$197</span>
            </div>
            <div className="flex justify-between pt-2 text-xl font-bold text-brand-text" data-id="element-74">
              <span data-id="element-75">VALOR TOTAL:</span> <span data-id="element-76">$562</span>
            </div>
          </div>

          <div className="space-y-2 mb-10" data-id="element-77">
            {strikethroughs.map((price, index) => <motion.div key={price} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.4
          }} className="text-2xl md:text-3xl font-black text-brand-navy/40 relative inline-block mx-auto w-full" data-id="element-78">
                HOY NO PAGAS {price}
                <motion.div initial={{
              scaleX: 0
            }} whileInView={{
              scaleX: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.4 + 0.2,
              duration: 0.3
            }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-1 bg-brand-accent origin-left" data-id="element-79"></motion.div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 1.4,
          duration: 0.5
        }} className="mb-10" data-id="element-80">
            <p className="text-xl font-bold text-brand-navy mb-2 uppercase" data-id="element-81">
              Hoy puedes acceder por solo
            </p>
            <div className="text-7xl md:text-9xl font-black text-brand-accent mb-4 leading-none" data-id="element-82">
              $27{' '}
              <span className="text-3xl md:text-4xl text-brand-navy" data-id="element-83">USD</span>
            </div>
            <p className="text-lg font-bold text-brand-navy bg-brand-card inline-block px-5 py-2 rounded-lg uppercase" data-id="element-84">
              Y recibir todo inmediatamente
            </p>
          </motion.div>

          <motion.a href="https://shop.beacons.ai/byesthermaria/Ebooks" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto inline-flex items-center justify-center gap-3 bg-brand-accent hover:bg-brand-accentHover text-white px-10 py-5 rounded-2xl font-black text-xl transition-colors shadow-xl shadow-brand-accent/30 uppercase" data-id="element-85">
            Sí, quiero acceso ahora
            <ArrowRight className="w-6 h-6" data-id="element-86" />
          </motion.a>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-brand-textSoft" data-id="element-87">
            <Lock className="w-4 h-4" data-id="element-88" />
            Pago 100% seguro y garantizado
          </div>
        </motion.div>
      </div>
    </section>;
}